import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath, Navigate } from "react-router-dom";

function hidePadding(url: string): boolean {
  return !!matchPath(
    "/stores/:storeId/redo-supplies/product/:productFamilyId",
    url,
  );
}

export const redoSuppliesRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Redo Supplies" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page hidePadding={hidePadding} /> };
    },
    children: [
      { index: true, element: <Navigate replace to="shop" /> },
      {
        path: "shop",
        handle: { breadcrumb: "Shop" },
        async lazy() {
          const { RedoSuppliesShopPage } = await import(
            "../../../redo-supplies/shop-page"
          );
          return { Component: RedoSuppliesShopPage };
        },
      },
      {
        path: "product/:productFamilyId",
        handle: { breadcrumb: "Product" },
        async lazy() {
          const { RedoSuppliesProductDetailPage } = await import(
            "../../../redo-supplies/product-detail-page"
          );
          return { Component: RedoSuppliesProductDetailPage };
        },
      },
      {
        path: "order-history",
        handle: { breadcrumb: "Order history" },
        async lazy() {
          const { RedoSuppliesOrderHistoryPage } = await import(
            "../../../redo-supplies/order-history-page"
          );
          return { Component: RedoSuppliesOrderHistoryPage };
        },
      },
    ],
  },
];
